<div
  class="kpi-card"
  [class.kpi-card--compact]="compact"
  [class.kpi-card--prominent-details]="kpi.key === 'sales_perm' || kpi.key === 'sales_temp' || kpi.key === 'cost_of_sales'"
  [class.kpi-card--cost-of-sales-details]="kpi.key === 'cost_of_sales'"
  [class.is-active]="isActive"
  [class.is-stale]="kpi.sourceState === 'stale'"
  [style.--kpi-accent]="accentColor"
  [style.--kpi-accent-dark]="accentColorDark"
  [class.cursor-pointer]="showAsTableEnabled"
  [attr.role]="showAsTableEnabled ? 'button' : null"
  [attr.tabindex]="showAsTableEnabled ? 0 : null"
  [attr.aria-label]="showAsTableEnabled ? actionLabel + ': ' + kpi.label : null"
  (click)="onClick()"
  (keydown)="onKeydown($event)"
>
  <div class="kpi-card__rail" aria-hidden="true"></div>

  @if (ribbonLabel) {
    <div class="kpi-card__ribbon-wrap" aria-hidden="true">
      <div class="kpi-card__ribbon-shadow"></div>
      <div class="kpi-card__ribbon">{{ ribbonLabel }}</div>
    </div>
  }

  <div class="kpi-card__body">
    <div class="flex min-w-0 items-center gap-2">
      <h3 class="kpi-card__title">{{ kpi.label }}</h3>
    </div>

    @if (kpi.sourceState === 'loading') {
      <div class="kpi-card__skeleton"></div>
    } @else if (kpi.sourceState === 'unavailable') {
      <div class="kpi-card__value kpi-card__value--muted">—</div>
    } @else {
      <div class="kpi-card__value">{{ kpi.value }}</div>
    }

    @if (showComparison && kpi.comparisonValue) {
      <div class="mt-1 flex items-baseline gap-1.5">
        <span class="text-[9px] font-semibold uppercase tracking-wide text-[#65A30D] dark:text-[#A3E635]">Comparison:</span>
        <span class="text-[11px] font-extrabold text-[#65A30D] dark:text-[#A3E635]">{{ kpi.comparisonValue }}</span>
      </div>
    }

    @if (kpi.details?.length) {
      <div class="kpi-card__details">
        @for (detail of kpi.details; track detail.label) {
          <div class="kpi-card__detail">
            <div class="kpi-card__detail-label">{{ detail.label }}</div>
            <div class="kpi-card__detail-value" [title]="detail.value">{{ detail.value }}</div>
          </div>
        }
      </div>
    }

    @if (kpi.key !== 'debtor_days' && !dateRangeLabel && kpi.iconImageUrl) {
      <img class="kpi-card__wash-image" [src]="kpi.iconImageUrl" alt="" aria-hidden="true" />
    } @else if (kpi.key !== 'debtor_days' && !dateRangeLabel) {
      <i class="pi kpi-card__wash-icon" [ngClass]="kpi.icon || 'pi-chart-bar'" aria-hidden="true"></i>
    }
  </div>
</div>
